export const INIT_LANDING_USERS = 'INIT_LANDING_USERS';
export const INIT_SEARCH_SUBSCRIBED_USERS = 'INIT_SEARCH_SUBSCRIBED_USERS';
export const INIT_SEARCH_SUBSCRIBED_GROUPS = 'INIT_SEARCH_SUBSCRIBED_GROUPS';
export const INIT_SEARCH_FAVOURITES_GROUPS = 'INIT_SEARCH_FAVOURITES_GROUPS';
export const INIT_SEARCH_MANAGED_GROUPS = 'INIT_SEARCH_MANAGED_GROUPS';
export const MARK_STARRED_GROUP = 'MARK_STARRED_GROUP'
export const ADD_RECENT_REQUEST = 'ADD_RECENT_REQUEST'
export const UPDATE_RECENT_REQUEST_TIMESTAMP = 'UPDATE_RECENT_REQUEST_TIMESTAMP'
export const UNMARK_STARRED_GROUP = 'UNMARK_STARRED_GROUP'